import React, { useEffect, useMemo } from 'react';

import { PaymentMethod } from '@/modules/employee/employee.types';
import { PersonalInformationPayload } from '@/modules/employee/Employee/PersonalInformation/hooks/usePersonalInformationState';
import { AllowedPaymentMethodConfig } from '@/modules/employer/types';

import useBank from './DirectDeposit/BankForm/useBank.store';
import { BankInfo } from './DirectDeposit/BankForm/useBankFields';
import { useGetExternalBankAccountsQuery } from './DirectDeposit/BankForm/useGetBankAccountsList.query';
import ImmediatelyButton, { DefaultPaymentMethodBlockProps } from './ImmediatelyButton';

interface Props {
  isRefund?: boolean;
  isLoading?: boolean;
  employee?: Partial<PersonalInformationPayload> | null;
  paymentMethod?: PaymentMethod;
  allowedPaymentMethodConfigs?: AllowedPaymentMethodConfig[];
  renderWrapper?: (props: DefaultPaymentMethodBlockProps) => React.ReactNode;
}
const Immediately: React.FC<Props> = ({
  isLoading,
  employee,
  paymentMethod,
  allowedPaymentMethodConfigs,
  isRefund,
  renderWrapper,
}) => {
  const paymentEmployeeFee = useMemo(() => allowedPaymentMethodConfigs
    ?.find((item) => item.paymentMethodType === paymentMethod?.type)?.paymentEmployeeFee,
  [paymentMethod, allowedPaymentMethodConfigs]);
  const { setBankAccountData } = useBank();
  const { externalBankAccounts, isLoading: isBankAccountLoading } = useGetExternalBankAccountsQuery(
    employee?.internalId
  );

  useEffect(() => {
    setBankAccountData(externalBankAccounts[0] as BankInfo);
  }, [externalBankAccounts, setBankAccountData]);

  return (
    <ImmediatelyButton
      isLoading={isLoading}
      isBankAccountLoading={isBankAccountLoading}
      isRefund={isRefund}
      employee={employee}
      paymentMethod={paymentMethod}
      paymentEmployeeFee={paymentEmployeeFee}
      renderWrapper={renderWrapper}
    />
  );
};

export default Immediately;
